
export { LucideIcon } from "/codebuild/output/src2410076634/src/packages/shared-components/src/components/LucideIcon.tsx"